/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./PendingMaintenanceTable.vue?vue&type=template&id=b6b8f56e"
import script from "./PendingMaintenanceTable.ts?vue&type=script&lang=ts&external"
export * from "./PendingMaintenanceTable.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports